export const css = {
    root: '_3DKFqWjQ',
    content: '_2Bgk4eho',
    title: '_3oxKmzME',
    subtitle: 'VGa_Sd5Q',
    actions: '_1jwfPm9g',
    ' _key': 'lcc-rcs/rcs-card'
};
export default css;
